// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3-Gy2","rootNoMargin":"styles_rootNoMargin__3yAoP"};